import { useEffect, useRef, useState, type ImgHTMLAttributes, type MouseEvent, type KeyboardEvent } from 'react'
import { refreshPreviewUrl } from '../api/preview-images'

/** Renew failed signed previews without reloading or overwriting an editable draft. */
export default function PreviewImage(props: ImgHTMLAttributes<HTMLImageElement>) {
  return <PreviewImageRequest key={props.src} {...props} />
}
function PreviewImageRequest({ src, alt, onError: _onError,onLoad, ...props }: ImgHTMLAttributes<HTMLImageElement>) {
  const [url, setUrl] = useState(src), [failed, setFailed] = useState(false), [refreshing, setRefreshing] = useState(false)
  const attempted = useRef(false), alive = useRef(true), request = useRef(false)
  useEffect(() => { alive.current = true; return () => { alive.current = false } }, [])
  const renew = async (force = false) => {
    if (!src || request.current) return
    request.current = true; attempted.current = true; setRefreshing(true)
    try {
      const fresh = await refreshPreviewUrl(src, force)
      if (!alive.current) return
      if (fresh) { setUrl(fresh); setFailed(false) }
      else setFailed(true)
    } catch { if (alive.current) setFailed(true) }
    finally { request.current = false; if (alive.current) setRefreshing(false) }
  }
  const retry = (event: MouseEvent | KeyboardEvent) => { event.preventDefault(); event.stopPropagation(); void renew(true) }
  if (failed || refreshing) return <span className={`preview-image-state ${props.className ?? ''}`} role="status">
    <span>{refreshing ? '正在重新加载预览…' : '预览图片加载失败'}</span>
    {!refreshing ? <span role="button" tabIndex={0} className="preview-image-retry" onClick={retry} onKeyDown={event => { if (event.key === 'Enter' || event.key === ' ') retry(event) }}>重新加载</span> : null}
  </span>
  return <img {...props} src={url} alt={alt} onLoad={event=>{attempted.current=false;onLoad?.(event)}} onError={() => { if (!attempted.current) void renew(); else setFailed(true) }} />
}
